import { useContext, useState } from "react"
import { Fetch } from "../../services/api";
import { UserContext } from "../../context/provider/UserProvider";
import { notify } from "../../utils/utils";

const urlActividades = process.env.REACT_APP_XPROJECT_API + "/Incidence";
export const useActividadesIncidencia = () => {
    const { stateUser } = useContext(UserContext);
    const [ loading, setLoading ] = useState(false);
    const [ incidenciaPorUID, setIncidenciaPorUID ] = useState([]);

    const listarIncidenciaPorUID = async (fechaInicio, fechaFin,) => {
        try{
            setLoading(true);
            const response = await Fetch({
                url: urlActividades + '/incidentList?' + new URLSearchParams({
                    CodArea: stateUser.codAreaActual,
                    FechaInicio: fechaInicio,
                    FechaFin: fechaFin,
                    CodEstado: 0,
                    UIDAccion: stateUser.nomUsuario.split('@')[0],
                    CodigoUrgencia: 0,
                    CodigoEmpresa: 0
                })
            })
            !response.isValid && notify(response.exceptions[0].description, 'error');
            setIncidenciaPorUID(response.isValid ? response.content : []);
            setLoading(false);
        }
        catch(error){
            setIncidenciaPorUID([]);
            setLoading(false);
            console.log('Error al listar incidencias')
        }
    }

    return{
        listarIncidenciaPorUID,
        incidenciaPorUID,
        loading,
    }
}